import { ProfessionalSellerDataClient } from '@/types/user/user.types';

export default async function doSubmitProfessionalSeller(
  professionalSeller: ProfessionalSellerDataClient
) {
  try {
    const response = await fetch('/api/professional-seller', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(professionalSeller),
    });
    return {
      ok: response.ok,
      data: await response.json(),
    };
  } catch (err) {
    return {
      ok: false,
      data: err,
    };
  }
}
